import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

const DevicesFiftyFifty = ({ blok }) => {
  const {
    title,
    subheading,
    body,
    button_text,
    button_link,
    button_icon,
    image,
    reverse_layout,
    quartz_background,
  } = blok;

  return (
    <section
      {...storyblokEditable(blok)}
      className={`w-full flex flex-col md:flex-row items-center gap-10 md:gap-0 ${
        reverse_layout ? "md:flex-row-reverse" : ""
      }`}
    >
      {/* Image Section */}
      <div
        className={`w-full md:w-1/2 flex justify-center items-center ${
          quartz_background ? "min-h-[200px] md:min-h-[763px]" : ""
        }`}
        style={{
          backgroundColor: quartz_background ? "#F9F9FA" : "transparent",
        }}
      >
        {image?.filename && (
          <img
            src={image.filename}
            alt={title}
            className="w-full max-w-lg object-contain"
          />
        )}
      </div>

      {/* Text Section */}
      <div className="w-full md:w-1/2 flex flex-col justify-center px-6 md:px-12 pb-8 md:pb-0">
        {title && (
          <h2 className="text-[#000] font-semibold text-[30px] mb-4">
            {title}
          </h2>
        )}

        {subheading && (
          <h3 className="text-[#000] font-medium text-[24px] mb-4">
            {subheading}
          </h3>
        )}

        {body && (
          <div className="text-[16px] leading-relaxed mb-6">
            {typeof body === "string"
              ? body
              : customRenderRichText(body)}
          </div>
        )}

        {button_text && (
          <a
            href={button_link?.url || "#"}
            className="inline-flex items-center gap-2 justify-center bg-[#1371DC] text-white font-medium rounded-full px-4"
            style={{
              height: "36px",
              width: "fit-content",
              maxWidth: "200px",
              minWidth: "80px",
            }}
          >
            {button_icon?.filename && (
              <img
                src={button_icon.filename}
                alt="Button icon"
                width={19}
                height={14}
                className="object-contain"
              />
            )}
            {button_text}
          </a>
        )}
      </div>
    </section>
  );
};

export default DevicesFiftyFifty;
